import PropTypes from 'prop-types';
import React from 'react';
import { Table } from 'react-bootstrap';
import { getOrgTermsContent } from '../../../../content/utils.js';
import ProjectRow from './ProjectRow.jsx';
import styles from './index.module.css';

ReportResultsTable.propTypes = {
  results: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
    })
  ).isRequired,
};

ReportResultsTable.defaultProps = {};

function ReportResultsTable({ results, participantType, hasParentPortfolios }) {
  return (
    <Table
      condensed
      hover
      style={{ tableLayout: 'fixed' }}
      className={styles.reportResultsTable}
    >
      <thead>
        <tr>
          <th colSpan={3}>{getOrgTermsContent('project')}&nbsp;Name</th>
          {participantType === 'Stakeholder' && (
            <React.Fragment>
              <th>Support for Change</th>
              <th>Engagement Frequency</th>
            </React.Fragment>
          )}
          {participantType !== 'Stakeholder' && <th>Completion</th>}
          <th>Owner</th>
          <th>Dates</th>
        </tr>
      </thead>
      <tbody>
        {results.map((project) => (
          <ProjectRow
            key={project.id}
            project={project}
            participantType={participantType}
            hasParentPortfolios={hasParentPortfolios}
          />
        ))}
      </tbody>
    </Table>
  );
}

export default ReportResultsTable;
